import { IOptions } from "components/DropdownSelect";
import { StatusBadgeVariant } from "components/StatusBadge";

export const opcoesStatusAutorizacao: IOptions[] = [
  { value: "PENDENTE", label: "Pendente" },
  { value: "PROCESSANDO", label: "Processando" },
  { value: "FINALIZADO", label: "Finalizado" },
  { value: "FALHA", label: "Falha" },
];

export const opcoesStatusProducao: IOptions[] = [
  { value: "PENDENTE", label: "Pendente" },
  { value: "ESTAMPADO", label: "Estampado" },
  { value: "FINALIZADO", label: "Finalizado" },
  { value: "FALHA", label: "Falha" },
];

// Map, e não objeto literal, para não herdar chaves de Object.prototype (ex.: "constructor").
const statusAutorizacaoPorCodigo = new Map<number, string>([
  [0, "PENDENTE"],
  [1, "PROCESSANDO"],
  [2, "FINALIZADO"],
  [3, "FALHA"],
]);

const statusProducaoPorCodigo = new Map<number, string>([
  [0, "PENDENTE"],
  [1, "ESTAMPADO"],
  [2, "FINALIZADO"],
  [3, "FALHA"],
  [4, "FALHA"],
]);

const variantePorStatus = new Map<string, StatusBadgeVariant>([
  ["PENDENTE", "aviso"],
  ["PROCESSANDO", "neutro"],
  ["ESTAMPADO", "info"],
  ["FINALIZADO", "sucesso"],
  ["FALHA", "erro"],
  ["FALHA_AUTORIZACAO", "erro"],
  ["FALHA_SENATRAN", "erro"],
  ["FALHA_PRENSA", "erro"],
]);

const labelPorStatus = new Map<string, string>([
  ...[...opcoesStatusAutorizacao, ...opcoesStatusProducao].map(
    (opcao): [string, string] => [String(opcao.value), opcao.label]
  ),
  ["FALHA_AUTORIZACAO", "Falha Autorização"],
  ["FALHA_SENATRAN", "Falha Senatran"],
  ["FALHA_PRENSA", "Falha Prensa"],
]);

export function chaveStatusAutorizacao(codigo: number): string {
  return statusAutorizacaoPorCodigo.get(codigo) ?? String(codigo);
}

export function chaveStatusProducao(codigo: number): string {
  return statusProducaoPorCodigo.get(codigo) ?? String(codigo);
}

export function varianteStatus(status: string): StatusBadgeVariant {
  return variantePorStatus.get(status) ?? "neutro";
}

export function labelStatus(status: string) {
  return labelPorStatus.get(status) ?? status;
}

const CODIGOS_STATUS_LOTE = [0, 1, 2, 3];

export const opcoesStatusAutorizacaoLote: IOptions[] = CODIGOS_STATUS_LOTE.map(
  (codigo) => ({
    value: codigo,
    label: labelStatus(chaveStatusAutorizacao(codigo)),
  })
);

export const opcoesStatusProducaoLote: IOptions[] = CODIGOS_STATUS_LOTE.map(
  (codigo) => ({
    value: codigo,
    label: labelStatus(chaveStatusProducao(codigo)),
  })
);

// Só a visualização do lote separa as falhas por tipo; as outras telas usam o genérico (Falha).
const statusAutorizacaoItemPorCodigo = new Map<number, string>([
  [3, "FALHA_AUTORIZACAO"],
]);

const statusProducaoItemPorCodigo = new Map<number, string>([
  [3, "FALHA_SENATRAN"],
  [4, "FALHA_PRENSA"],
]);

export function chaveStatusAutorizacaoItem(codigo: number): string {
  return (
    statusAutorizacaoItemPorCodigo.get(codigo) ?? chaveStatusAutorizacao(codigo)
  );
}

export function chaveStatusProducaoItem(codigo: number): string {
  return statusProducaoItemPorCodigo.get(codigo) ?? chaveStatusProducao(codigo);
}

export const opcoesStatusAutorizacaoItem: IOptions[] = [0, 1, 2, 3].map(
  (codigo) => ({
    value: codigo,
    label: labelStatus(chaveStatusAutorizacaoItem(codigo)),
  })
);

export const opcoesStatusProducaoItem: IOptions[] = [0, 1, 2, 3, 4].map(
  (codigo) => ({
    value: codigo,
    label: labelStatus(chaveStatusProducaoItem(codigo)),
  })
);
